export const storeNotification = {
    namespaced: true,
    state: {
        EventStateItem: null,
        UserStateInfo: undefined,
        LiveStateInfo: undefined
    },
    getters: {
        Agenda(state) {
            return state.EventStateItem?.agendaItem;
        },
        roomState(state) {
            return state.EventStateItem?.roomState;
        },
        active(state) {
            return state.EventStateItem?.active;
        },
        access(state) {
            return state.UserStateInfo?.access && state.EventStateItem?.roomState == "live"
        },
        userType(state) {
            return state.UserStateInfo.userType;
        },
        GET_LiveStateInfo(state) {
            return state.LiveStateInfo;
        },
        GET_ShowTabs(state) {
            if (state.LiveStateInfo != undefined)
                return state.LiveStateInfo.show;
            else
                false;
        }

    },
    mutations: {
        SET_EventStateItem(state, payload) {
            state.EventStateItem = payload;
        },
        SET_UserStateInfo(state, payload) {
            state.UserStateInfo = payload;
        },
        SET_LiveStateInfo(state, payload) {
            state.LiveStateInfo = payload;
        }
    },
    actions: {
        async getLiveStateInfo({ commit }) {            
            var res = (await window.axios.get('api/webapp/livestateinfo/get')).data.liveStateInfo;            
            commit('SET_LiveStateInfo', res);
        }

    }
}